/** A name, in the shape every avatar call site already has one. */
export interface InitialsSource {
  firstName?: string | null;
  lastName?: string | null;
}

/**
 * Avatar initials: the first character of each present name part, uppercased.
 *
 * One rule for both portals. The nav account blocks used to build these inline without
 * uppercasing, so the same person read "jd" in the nav and "JD" on their profile.
 */
export function initials({ firstName, lastName }: InitialsSource): string {
  return [firstName, lastName]
    .map((part) => {
      const trimmed = part?.trim();
      if (!trimmed) return '';
      // Spread, not [0]: a name opening with an astral character (an accented glyph stored as a
      // surrogate pair, say) would otherwise yield half a code point and render as a replacement box.
      return [...trimmed][0].toUpperCase();
    })
    .join('');
}
